import React from 'react';
import moment from 'moment-timezone';
// Configure weekdays to start on Monday (1) not Sunday (0)
moment.updateLocale('en', {
    week: {
        dow: 1
    }
});
export var AccurityTimezoneContext = React.createContext(undefined);
export var AccurityTimezoneProvider = AccurityTimezoneContext.Provider;
export var useAccurityTimezone = function () { return React.useContext(AccurityTimezoneContext) || moment.tz.guess(); };
//# sourceMappingURL=AccurityTimezoneProvider.js.map